<template>
  <header class="lg:px-16 sm:px-0 bg-gray-900 flex flex-wrap items-center lg:py-0 py-2" v-if="authenticated">
  <div class="flex-1 flex justify-between items-center">
    <router-link class="navbar-brand lg:p-4 py-2 px-0"
    :to="{ name: 'dashboard' }">
      <img src="../assets/images/logo-1.svg" class="logonavbar">
    </router-link>
  </div>
  <label for="menu-toggle" class="pointer-cursor lg:hidden block">
    <svg class="fill-current text-white" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><title>menu</title><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"></path></svg></label>
  <input class="hidden" type="checkbox" id="menu-toggle" />

<div class="hidden lg:flex lg:items-center lg:w-auto w-full" id="menu">
  <nav>
    <ul class="lg:flex items-center justify-between text-base text-white pt-4 lg:pt-0">
        
      <li class="nav-item">
          <router-link 
            class="lg:p-4 py-3 px-0 block border-b-2 border-transparent hover:border-indigo-400"
          :to="{ name: 'servers' }">
          Servidores
        </router-link>
      </li>
      <li class="nav-item">
          <router-link 
            class="lg:p-4 py-3 px-0 block border-b-2 border-transparent hover:border-indigo-400"
          :to="{ name: 'dashboard' }">
          Grupo de Tarefas
        </router-link>
      </li>
      <li class="nav-item">
          <router-link 
            class="lg:p-4 py-3 px-0 block border-b-2 border-transparent hover:border-indigo-400"
          :to="{ name: 'dashboard' }">
          Tarefas
        </router-link>
      </li>
      <!-- <li><a class="lg:p-4 py-3 px-0 block border-b-2 border-transparent hover:border-indigo-400 lg:mb-0 mb-2" href="#">Support</a></li> -->
    </ul>
  </nav>

  <!-- <a href="#" class="lg:ml-4 flex items-center justify-start lg:mb-0 mb-4 pointer-cursor">
    <img class="rounded-full w-10 h-10 border-2 border-transparent hover:border-indigo-400" src="https://pbs.twimg.com/profile_images/1128143121475342337/e8tkhRaz_normal.jpg" alt="Andy Leverenz">
  </a> -->

<div
  v-clickaway="closeDropDown"
  class="relative"
>
  <button
    @click="open = !open"
    class="flex flex-row items-center w-full px-1 py-1 mt-2 text-sm font-semibold 
      text-left bg-transparent rounded-full md:w-auto md:mt-0 md:ml-2 
      bg-gray-300 
      hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 
      focus:outline-none focus:shadow-outline"
  >
    <img src="https://www.gravatar.com/avatar/00000000000000000000000000000000?s=40&d=mp&f=y" 
      class="w-auto h-6 rounded-full" alt="" />
    <span class="px-1">{{user.fullName}}</span>
  </button>
  <transition
    enter-active-class="transition duration-100 ease-out"
    leave-active-class="transition duration-75 ease-in"
    enter-class="transform opacity-0 scale-95"
    enter-to-class="transform opacity-100 scale-100"
    leave-class="transform opacity-100 scale-100"
    leave-to-class="transform opacity-0 scale-95"
>
<div
    v-if="open"
    class="absolute right-0 w-full mt-2 origin-top-right rounded-md shadow-lg md:w-48"
  >
  <!-- <div
    x-show="open"
    x-transition:enter="transition ease-out duration-100"
    x-transition:enter-start="transform opacity-0 scale-95"
    x-transition:enter-end="transform opacity-100 scale-100"
    x-transition:leave="transition ease-in duration-75"
    x-transition:leave-start="transform opacity-100 scale-100"
    x-transition:leave-end="transform opacity-0 scale-95"
    class="absolute right-0 w-full mt-2 origin-top-right rounded-md shadow-lg md:w-48"
  > -->
    <div class="px-2 py-2 bg-white rounded-md shadow">
      <a
        class="block px-4 py-2 mt-2  bg-transparent rounded-lg  text-sm font-semibold md:mt-0 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline"
        >Minha COnta</a
      >
      <a
        class="block px-4 py-2 mt-2 
          bg-transparent rounded-lg  text-sm font-semibold md:mt-0 
          hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 
          focus:outline-none focus:shadow-outline"
          style="cursor: pointer"
        @click.prevent="signOut"
        >Sair</a
      >
    </div>
  </div>
  </transition>
</div>


  <!-- <div class="group inline-block">
    <button
      class="outline-none focus:outline-none border px-3 py-1 bg-white rounded-sm flex items-center min-w-32"
    >
      <span class="pr-1 font-semibold flex-1">{{user.fullName}}</span>
      <span>
        <svg
          class="fill-current h-4 w-4 transform group-hover:-rotate-180
          transition duration-150 ease-in-out"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path
            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
          />
        </svg>
      </span>
    </button>
    <ul
      class="bg-white border rounded-sm transform scale-0 group-hover:scale-100 absolute 
    transition duration-150 ease-in-out origin-top min-w-32"
    >
      <li class="rounded-sm px-3 py-1 hover:bg-gray-100">
        <a class="dropdown-item" @click.prevent="signOut" style="cursor: pointer">
          Sair
        </a>
      </li>
    </ul>
  </div>
   -->

</div>

</header>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    data: function(){
      return {
        open: false
      }
    },
    computed: {
      ...mapGetters({
        authenticated: 'auth/authenticated',
        user: 'auth/user'
      })
    },

    methods: {
      ...mapActions({
        signOutAction: 'auth/signOut'
      }),

      closeDropDown(){
        this.open = false;
      },

      signOut () {
        this.signOutAction().then(() => {
          this.$router.replace({
            name: 'login'
          })
        })
      }
    }
  }
</script>